// extracted by mini-css-extract-plugin
export default {"mobile":"_6qIeRpTLa7ohmRHWp+7MYw==","adjustUpdateCardHeight":"CKzaiRCn6kItQo089nZdkA==","moveCardUp":"XoYp0TK3HCGb+hIdNwtuDg=="};